import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaEye, FaHeart } from 'react-icons/fa';
import { MdOutlineMenuBook } from 'react-icons/md';
import api from '../services/api';
import '../styles/SearchResults.css';
import getBookCoverUrl from '../utils/getBookCoverUrl';
import { getProfileImageUrl } from '../utils/getProfileImageUrl';

function SearchResults() {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get('query');
  const [activeTab, setActiveTab] = useState('kitaplar');
  const [booksByTitle, setBooksByTitle] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [following, setFollowing] = useState({});
  const navigate = useNavigate();
  const currentUserId = localStorage.getItem('userId');
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchSearchResults = async () => {
      try {
        const response = await api.get(`/search/search?query=${encodeURIComponent(query)}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        setBooksByTitle(response.data.booksByTitle || []);
        setAuthors(response.data.authors || []);
        fetchFollowStatus(response.data.authors || []);
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    };

    const fetchFollowStatus = async (authors) => {
      try {
        const followStatus = {};
        for (const author of authors) {
          const followResponse = await api.get(`/search/isFollowing/${currentUserId}/${author.user_id}`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          followStatus[author.user_id] = followResponse.data.isFollowing;
        }
        setFollowing(followStatus);
      } catch (error) {
        console.error('Error fetching follow status:', error);
      }
    };

    if (query) {
      fetchSearchResults();
    }
  }, [query, currentUserId, token]);

  const handleBookClick = (bookId) => {
    navigate(`/book/${bookId}`);
  };

  const handleUserClick = (userId) => {
    navigate(`/profile/${userId}`);
  };

  const toggleFollow = async (userId, event) => {
    // Prevent clicking the button from navigating to the profile
    event.stopPropagation();
    
    try {
      const endpoint = following[userId] ? `/search/unfollow/${currentUserId}/${userId}` : `/search/follow/${currentUserId}/${userId}`;
      await api.post(endpoint, null, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setFollowing(prev => ({ ...prev, [userId]: !prev[userId] }));
    } catch (error) {
      console.error('Error while toggling follow:', error);
    }
  };

  return (
    <div className="search-results">
      <h1>"{query}" Arama Sonuçları</h1>
      
      <div className="tabs">
        <button
          className={activeTab === 'kitaplar' ? 'active' : ''}
          onClick={() => setActiveTab('kitaplar')}
        >
          Kitaplar
        </button>
        <button
          className={activeTab === 'kullanicilar' ? 'active' : ''}
          onClick={() => setActiveTab('kullanicilar')}
        >
          Kullanıcılar
        </button>
      </div>
      
      <div className="tab-content">
        {activeTab === 'kitaplar' && (
          <div className="book-grid">
            {booksByTitle.length > 0 ? (
              booksByTitle.map((book) => (
                <div
                  key={book.book_id}
                  className="book-card"
                  onClick={() => handleBookClick(book.book_id)}
                >
                  <img 
                    src={getBookCoverUrl(book.cover_image_url)} 
                    alt={book.title} 
                    className="book-cover" 
                  />
                  <h2 className="book-title">{book.title}</h2>
                  <p className="book-author">{book.author}</p>
                  <div className="book-stats">
                    <span><FaEye /> {book.total_views}</span>
                    <span><FaHeart /> {book.total_likes}</span>
                    <span><MdOutlineMenuBook /> {book.chapters}</span>
                  </div>
                </div>
              ))
            ) : (
              <p className="empty-message">Kitap bulunamadı.</p>
            )}
          </div>
        )}
        
        {activeTab === 'kullanicilar' && (
          <div className="author-list">
            {authors.length > 0 ? (
              authors.map((author) => (
                <div 
                  key={author.user_id} 
                  className="author-card"
                  onClick={() => handleUserClick(author.user_id)}
                >
                  <div className="author-info">
                    <img
                      src={getProfileImageUrl(author.profile_image_url)}
                      alt={author.author}
                      className="author-image"
                    />
                    <div>
                      <h2 className="author-name">{author.author}</h2>
                      <div className="author-stats">Kitap Sayısı: {author.total_books}</div>
                    </div>
                  </div>
                  <button
                    className={`follow-button ${following[author.user_id] ? 'following-button' : ''}`}
                    onClick={(e) => toggleFollow(author.user_id, e)}
                  >
                    {following[author.user_id] ? 'Takibi Bırak' : 'Takip Et'}
                  </button>
                </div>
              ))
            ) : (
              <p className="empty-message">Kullanıcı bulunamadı.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchResults;